import { Permission } from 'entities/user';
import { TFunction } from 'i18next';

export interface IRoleInput {
  name: string;
  description: string;
  permissions: Permission[];
  users?: string[];
}

export interface IRoleResult {
  id: string;
  name: string;
  description: string;
  permissions: Permissions[];
  users: string[];
}

export interface IStep {
  label: string;
  route: string;
  number: number;
}

const stepRoutes: string[] = ['/role-setup', '/summary'];

export const getStep = (step: string): number => {
  return stepRoutes.indexOf(`/${step}`) + 1;
};

export const getStepRoute = (stepNumber: number): string => {
  return `/user-management/roles/create${stepRoutes[stepNumber - 1]}`;
};

export const getSteps = (t: TFunction): IStep[] => [
  { label: t('newRole.steps.step1'), route: stepRoutes[0], number: 1 },
  { label: t('newRole.steps.step2'), route: stepRoutes[1], number: 2 },
];
